import type { CmsColor } from "@/lib/cms/cms-theme.constants";
import { createContext, useContext, type ReactNode } from "react";

type CmsThemeEditorContextValue = {
  colors: CmsColor[];
  onColorsChange?: (colors: CmsColor[]) => void;
};

const CmsThemeEditorContext = createContext<CmsThemeEditorContextValue>({
  colors: [],
});

export function CmsThemeEditorProvider({
  colors,
  onColorsChange,
  children,
}: {
  colors: CmsColor[];
  onColorsChange?: (colors: CmsColor[]) => void;
  children: ReactNode;
}) {
  return (
    <CmsThemeEditorContext.Provider value={{ colors, onColorsChange }}>
      {children}
    </CmsThemeEditorContext.Provider>
  );
}

export function useCmsThemeEditorPalette() {
  return useContext(CmsThemeEditorContext).colors;
}

export function useCmsThemeEditorOnColorsChange() {
  return useContext(CmsThemeEditorContext).onColorsChange;
}
